import { useMemo } from "react";
import { createSubscribableArray, SubscribableArray, useSubscribableArray } from "../utils/subscribable-array";
import { joinMiddlewares } from "./join";
import { MessageMiddlewareBuilder } from "./message-middleware";

// registration would like below
// (window["xappMsgMiddlewares"] = window["xappMsgMiddlewares"] || []).push(next => (msg, ctx) => next(msg, ctx));

const empty = [];

interface StorageType<T> {
    get(): readonly T[] | SubscribableArray<T> | undefined;
    set(vals: SubscribableArray<T>): void;
};

function createStorage<T>(global: unknown, key: string): StorageType<T> {
    return {
        get: () => global[key],
        set: val => global[key] = val
    };
}

export function useGlobalSubscribableArray<T>(storage: StorageType<T>): readonly T[] {
    const raw = storage.get() || (empty as readonly T[]);
    const array = Array.isArray(raw) ? createSubscribableArray<T>(raw) : raw as SubscribableArray<T>;
    if (array !== raw) {
        storage.set(array);
    }
    return useSubscribableArray(array);
}

export function useLateMiddlewaresBuilder(storage: StorageType<MessageMiddlewareBuilder>): MessageMiddlewareBuilder {
    const middlewares = useGlobalSubscribableArray(storage);

    return useMemo<MessageMiddlewareBuilder>(() => joinMiddlewares(middlewares), [middlewares]);
}

const storage = createStorage<MessageMiddlewareBuilder>(globalThis, "xappMsgMiddlewares");

export function useLateMiddleware(): MessageMiddlewareBuilder {
    return useLateMiddlewaresBuilder(storage);
}
